import { useStore } from "@policoders/di";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { LoginStore } from "./login.store";

interface IStateType {
  from: { pathname: string };
}

export const useLogin = () => {
  const { state }: { state: IStateType } = useLocation();
  const store = useStore<LoginStore>("LoginStore");

  const [authenticated, setAuthenticated] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "emailInput") setEmail(e.target.value);
    if (e.target.name === "passwordInput") setPassword(e.target.value);
  };

  const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    store.login(email, password);
  };

  useEffect(() => {
    const subscriber = store.state$.subscribe(value => {
      setAuthenticated(value.authenticated);
      if (value.error) setErrorMessage(value.error);
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [store]);

  return {
    authenticated,
    email,
    password,
    errorMessage,
    pathname: state?.from?.pathname,
    handleLogin,
    handleChange,
  };
};
